import { useMemo, useState } from "react"
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material"
import { CustomTable } from "@/components/Tables/CustomTable"
import { columns } from "./Columns"
import { useNavigate } from "react-router-dom"
import { useAppSelector } from "@/lib/hooks"
import { isAdminPortal } from "@/utilities/domain"
import {
  ReportBranchFilter,
  ReportBranchProvider,
  useReportBranch,
  withBranchColumn,
} from "@/components/Reports/ReportBranchFilter"

const adminColumns = withBranchColumn(columns)

export default function WebsiteOrderList() {
  return (
    <>
      <div className="breadcrumb-card">
        <h5>Website Orders</h5>
      </div>

      <ReportBranchProvider>
        <WebsiteOrderTable />
      </ReportBranchProvider>
    </>
  )
}

function WebsiteOrderTable() {
  const permissions = new Set(
    useAppSelector((state) => state.auth.user?.permissions ?? [])
  )
  const navigate = useNavigate()
  const [status, setStatus] = useState("")
  // The company admin portal lists every branch's orders, or a selected one
  const adminPortal = isAdminPortal()
  const { branchId } = useReportBranch()
  const websiteOrderFilters = useMemo(
    () => ({ type: "website", ...(status && { status }), branch_id: branchId }),
    [status, branchId]
  )
  const exportParams = useMemo(() => ({ branch_id: branchId }), [branchId])

  return (
    <>
      <CustomTable
        label="Website Orders"
        columns={adminPortal ? adminColumns : columns}
        apiPath="order"
        revalidateQuery="website-orders"
        hardcodedFilters={websiteOrderFilters}
        addBtn={false}
        onView={(rowData) => {
          navigate(`/pos/website-orders/${rowData.id}`)
        }}
        showEdit={false}
        showDelete={false}
        onExport={permissions.has("operations-exports-create")}
        exportApiPath="website-orders-export"
        exportParams={adminPortal ? exportParams : undefined}
        renderFilters={() => (
          <div className="flex flex-wrap gap-2">
            <ReportBranchFilter sx={{ mb: 0 }} />
            <FormControl size="small" sx={{ minWidth: 150 }}>
              <InputLabel id="website-order-status-label">Status</InputLabel>
              <Select
                labelId="website-order-status-label"
                label="Status"
                value={status}
                onChange={(event) => setStatus(event.target.value)}
              >
                <MenuItem value="">All statuses</MenuItem>
                <MenuItem value="2">Pending</MenuItem>
                <MenuItem value="1">Accepted</MenuItem>
                <MenuItem value="4">Cancelled</MenuItem>
              </Select>
            </FormControl>
          </div>
        )}
      />
    </>
  )
}
